import { Pipe, PipeTransform } from '@angular/core';

/**
 * Resolves a roster's locally-stored profile image path from its id.
 * Profile images are downloaded as 200x200 webp files named
 * `{first 8 chars of roster.id}_p.webp` and served from /public.
 */
@Pipe({ name: 'profileImage' })
export class ProfileImagePipe implements PipeTransform {
  transform(id: string | null | undefined): string {
    if (!id) return '';
    return `/${id.substring(0, 8)}_p.webp`;
  }
}
